import { makeStyles, createStyles } from "@mui/styles";
import usePrimaryColor from "@root/hooks/usePrimaryColor";

export const SupportButton = ({
    title,
    href,
    icon
}: IButton) => {

    const { defPrimaryColor } = usePrimaryColor();

    const useStyles = makeStyles(() =>
        createStyles({
            button: {
                borderRadius: "8px",
                backgroundColor: "#F2F2F2",
                color: "#333333",
                padding: "16px",
                fontSize: "14px",
                fontFamily: "Wix Madefor Text",
                fontWeight: 400,
                height: "56px",
                display: "flex",
                lineHeight: "20px",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "auto",
                gap: "8px",
                border: "none",
                cursor: "pointer",
                textDecoration: "none",
            },
            group: {
                display: "flex",
                alignItems: "center",
                gap: "8px",
            },
        })
    );

    const classes = useStyles();

    return (
        <a href={href} className={`${classes.button} w-full`}>
            <div className={classes.group}>
                {icon}
                {title}
            </div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1712_5476)">
                    <path d="M8.5 7.5L13.5 2.5" stroke={defPrimaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.5 6.5L13.4994 2.50062L9.5 2.5" stroke={defPrimaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M11.5 8.75V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V5C2.5 4.86739 2.55268 4.74021 2.64645 4.64645C2.74021 4.55268 2.86739 4.5 3 4.5H7.25" stroke={defPrimaryColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_1712_5476">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </a>
    );
};

interface IButton {
    title?: string;
    href?: string;
    icon?: React.ReactNode;
}